import _ from "lodash";
import Vue from "vue";
import Vuex from "vuex";
import { vuexfireMutations } from "vuexfire";

import { ALQUANT_INDICATORS } from "@/assets/constants/indicators/alquant";

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import state from "./state";

Vue.use(Vuex);

// Auth
import moduleAuth from "./auth/moduleAuth.js";
// Assets
import moduleAssets from "./modules/assets.js";
// Benchmarks
import moduleBenchmarks from "./modules/benchmarks.js";
// Custom Indicators
import moduleCustomIndicators from "./modules/customIndicators.js";
// Indicators' tools
import moduleToolTactical from "./modules/indicators/tools/toolTactical";
// Portfolios
import modulePortfolios from "./modules/portfolios.js";
// User information
import moduleUserInfo from "./modules/userInfo.js";

class ImportError extends Error {}

/* INDICATORS */

// Create indicators modules
const loadIndicatorModule = (indicatorName) => {
  try {
    return require(`@/store/modules/indicators/${indicatorName}.js`).default;
  } catch (e) {
    throw new ImportError(`Unable to import indicator module '${indicatorName}'`);
  }
};
const allIndicatorsModules = ALQUANT_INDICATORS.map((indicatorName) => {
  try {
    let moduleIndicator = loadIndicatorModule(indicatorName);
    return [indicatorName, moduleIndicator];
  } catch (err) {
    if (err instanceof ImportError) {
      // Need to deep clone otherwise the different modules will share the same state.
      let moduleIndicator = _.cloneDeep(require("@/store/modules/indicators.js").default);
      return [indicatorName, moduleIndicator];
    } else {
      throw err;
    }
  }
});
// Add tools if at least one indicator.
if (allIndicatorsModules.length > 0) {
  allIndicatorsModules.push(["toolTactical", moduleToolTactical]);
}
const mapIndicatorsModules = new Map(allIndicatorsModules);

export default new Vuex.Store({
  getters,
  mutations: {
    ...mutations,
    ...vuexfireMutations,
  },
  state,
  actions,
  modules: {
    auth: moduleAuth,
    userInfo: moduleUserInfo,
    assets: moduleAssets,
    benchmarks: moduleBenchmarks,
    portfolios: modulePortfolios,
    customIndicators: moduleCustomIndicators,
    ...Object.fromEntries(mapIndicatorsModules),
  },
  strict: process.env.NODE_ENV !== "production",
});
